export const ZZZDeadlyCharData = [
  {
    char: 'anby-demara',
    name: 'Anby',
    rarity: '4*',
    app_free: 2.68,
    round_free: 17259,
    app_dupes: 0.85,
    round_dupes: 23922,
    current_app_rate: 5.4,
    prev_app_rate: 5.61,
    current_avg_score: 17750,
    prev_avg_score: 17252,
    boss_1_usage: 1.97,
    boss_1_score: 18810,
    boss_2_usage: 0.16,
    boss_2_score: 0,
    boss_3_usage: 3.67,
    boss_3_score: 17132
  },
  {
    char: 'anby-demara-soldier-0',
    name: 'Anby S0',
    rarity: 'Limited 5*',
    app_free: 6.72,
    round_free: 20687,
    app_dupes: 8.53,
    round_dupes: 37453,
    current_app_rate: 37.81,
    prev_app_rate: 41.13,
    current_avg_score: 26549,
    prev_avg_score: 24557,
    boss_1_usage: 1.03,
    boss_1_score: 25837,
    boss_2_usage: 0.31,
    boss_2_score: 0,
    boss_3_usage: 39.49,
    boss_3_score: 26622
  },
  {
    char: 'anton',
    name: 'Anton',
    rarity: '4*',
    app_free: 0.32,
    round_free: 0,
    app_dupes: 0.1,
    round_dupes: 0,
    current_app_rate: 0.51,
    prev_app_rate: 0.59,
    current_avg_score: 23071,
    prev_avg_score: 23041,
    boss_1_usage: 0.04,
    boss_1_score: 0,
    boss_2_usage: 0,
    boss_2_score: 0,
    boss_3_usage: 0.52,
    boss_3_score: 23157
  },
  {
    char: 'astra-yao',
    name: 'Astra Yao',
    rarity: 'Limited 5*',
    app_free: 16.61,
    round_free: 26502,
    app_dupes: 23.47,
    round_dupes: 41264,
    current_app_rate: 78.23,
    prev_app_rate: 81.78,
    current_avg_score: 30369,
    prev_avg_score: 26558,
    boss_1_usage: 34.99,
    boss_1_score: 30782,
    boss_2_usage: 18.93,
    boss_2_score: 30076,
    boss_3_usage: 30.83,
    boss_3_score: 30065
  },
  {
    char: 'ben',
    name: 'Ben',
    rarity: '4*',
    app_free: 0.14,
    round_free: 0,
    app_dupes: 0.07,
    round_dupes: 0,
    current_app_rate: 0.34,
    prev_app_rate: 0.73,
    current_avg_score: 19696,
    prev_avg_score: 19404,
    boss_1_usage: 0.25,
    boss_1_score: 0,
    boss_2_usage: 0.02,
    boss_2_score: 0,
    boss_3_usage: 0.09,
    boss_3_score: 0
  },
  {
    char: 'billy-kid',
    name: 'Billy',
    rarity: '4*',
    app_free: 0.29,
    round_free: 0,
    app_dupes: 0.02,
    round_dupes: 0,
    current_app_rate: 0.48,
    prev_app_rate: 0.48,
    current_avg_score: 22395,
    prev_avg_score: 17560,
    boss_1_usage: 0.4,
    boss_1_score: 21561,
    boss_2_usage: 0,
    boss_2_score: 0,
    boss_3_usage: 0.11,
    boss_3_score: 0
  },
  {
    char: 'burnice',
    name: 'Burnice',
    rarity: 'Limited 5*',
    app_free: 6.87,
    round_free: 22861,
    app_dupes: 12.56,
    round_dupes: 35756,
    current_app_rate: 42.85,
    prev_app_rate: 48,
    current_avg_score: 27066,
    prev_avg_score: 23265,
    boss_1_usage: 11.1,
    boss_1_score: 26987,
    boss_2_usage: 29.15,
    boss_2_score: 27897,
    boss_3_usage: 7.25,
    boss_3_score: 24293
  },
  {
    char: 'caesar',
    name: 'Caesar',
    rarity: 'Limited 5*',
    app_free: 4.92,
    round_free: 21117,
    app_dupes: 10.96,
    round_dupes: 33327,
    current_app_rate: 33.46,
    prev_app_rate: 42.62,
    current_avg_score: 24710,
    prev_avg_score: 23276,
    boss_1_usage: 15.2,
    boss_1_score: 26171,
    boss_2_usage: 7.36,
    boss_2_score: 20439,
    boss_3_usage: 13.66,
    boss_3_score: 24774
  },
  {
    char: 'corin',
    name: 'Corin',
    rarity: '4*',
    app_free: 0.27,
    round_free: 0,
    app_dupes: 0.12,
    round_dupes: 0,
    current_app_rate: 0.75,
    prev_app_rate: 0.9,
    current_avg_score: 23554,
    prev_avg_score: 21203,
    boss_1_usage: 0.47,
    boss_1_score: 24461,
    boss_2_usage: 0,
    boss_2_score: 0,
    boss_3_usage: 0.33,
    boss_3_score: 0
  },
  {
    char: 'ellen',
    name: 'Ellen',
    rarity: 'Limited 5*',
    app_free: 4.44,
    round_free: 17703,
    app_dupes: 8.84,
    round_dupes: 25545,
    current_app_rate: 25.43,
    prev_app_rate: 12.74,
    current_avg_score: 20525,
    prev_avg_score: 18489,
    boss_1_usage: 24.78,
    boss_1_score: 20940,
    boss_2_usage: 1.79,
    boss_2_score: 14541,
    boss_3_usage: 0.52,
    boss_3_score: 15891
  },
  {
    char: 'evelyn',
    name: 'Evelyn',
    rarity: 'Limited 5*',
    app_free: 5.11,
    round_free: 23245,
    app_dupes: 5.49,
    round_dupes: 40257,
    current_app_rate: 24.12,
    prev_app_rate: 46.53,
    current_avg_score: 27991,
    prev_avg_score: 24134,
    boss_1_usage: 18.19,
    boss_1_score: 29315,
    boss_2_usage: 1.92,
    boss_2_score: 18297,
    boss_3_usage: 5.69,
    boss_3_score: 26253
  },
  {
    char: 'grace-howard',
    name: 'Grace',
    rarity: 'Standard 5*',
    app_free: 0.99,
    round_free: 18289,
    app_dupes: 1.13,
    round_dupes: 27269,
    current_app_rate: 3.55,
    prev_app_rate: 3.04,
    current_avg_score: 19353,
    prev_avg_score: 19566,
    boss_1_usage: 0.29,
    boss_1_score: 0,
    boss_2_usage: 1.73,
    boss_2_score: 20738,
    boss_3_usage: 1.9,
    boss_3_score: 18542
  },
  {
    char: 'harumasa',
    name: 'Harumasa',
    rarity: 'Limited 5*',
    app_free: 5.54,
    round_free: 20545,
    app_dupes: 4.94,
    round_dupes: 29065,
    current_app_rate: 17.95,
    prev_app_rate: 20.24,
    current_avg_score: 22007,
    prev_avg_score: 19141,
    boss_1_usage: 0.54,
    boss_1_score: 18083,
    boss_2_usage: 0.85,
    boss_2_score: 0,
    boss_3_usage: 18.02,
    boss_3_score: 22140
  },
  {
    char: 'jane-doe',
    name: 'Jane Doe',
    rarity: 'Limited 5*',
    app_free: 3.97,
    round_free: 22802,
    app_dupes: 5.83,
    round_dupes: 35258,
    current_app_rate: 17.74,
    prev_app_rate: 20.66,
    current_avg_score: 25552,
    prev_avg_score: 19256,
    boss_1_usage: 12.1,
    boss_1_score: 28382,
    boss_2_usage: 1.5,
    boss_2_score: 17020,
    boss_3_usage: 5.41,
    boss_3_score: 21303
  },
  {
    char: 'koleda',
    name: 'Koleda',
    rarity: 'Standard 5*',
    app_free: 2.27,
    round_free: 20400,
    app_dupes: 1.28,
    round_dupes: 31395,
    current_app_rate: 7.86,
    prev_app_rate: 17.32,
    current_avg_score: 24231,
    prev_avg_score: 21222,
    boss_1_usage: 6.27,
    boss_1_score: 25484,
    boss_2_usage: 0.66,
    boss_2_score: 16322,
    boss_3_usage: 1.48,
    boss_3_score: 20948
  },
  {
    char: 'lighter',
    name: 'Lighter',
    rarity: 'Limited 5*',
    app_free: 2.03,
    round_free: 22375,
    app_dupes: 4.26,
    round_dupes: 36132,
    current_app_rate: 13.84,
    prev_app_rate: 19.4,
    current_avg_score: 27082,
    prev_avg_score: 26467,
    boss_1_usage: 9.49,
    boss_1_score: 28964,
    boss_2_usage: 4,
    boss_2_score: 23248,
    boss_3_usage: 1.48,
    boss_3_score: 25630
  },
  {
    char: 'lucy',
    name: 'Lucy',
    rarity: '4*',
    app_free: 6.89,
    round_free: 20797,
    app_dupes: 11.47,
    round_dupes: 34544,
    current_app_rate: 39.82,
    prev_app_rate: 49.53,
    current_avg_score: 25511,
    prev_avg_score: 22519,
    boss_1_usage: 11.1,
    boss_1_score: 24800,
    boss_2_usage: 25.83,
    boss_2_score: 26963,
    boss_3_usage: 7.14,
    boss_3_score: 22632
  },
  {
    char: 'lycaon',
    name: 'Lycaon',
    rarity: 'Standard 5*',
    app_free: 5.02,
    round_free: 18632,
    app_dupes: 12.56,
    round_dupes: 29827,
    current_app_rate: 35.7,
    prev_app_rate: 31.62,
    current_avg_score: 22317,
    prev_avg_score: 26439,
    boss_1_usage: 21.17,
    boss_1_score: 21821,
    boss_2_usage: 17.28,
    boss_2_score: 23229,
    boss_3_usage: 0.55,
    boss_3_score: 16846
  },
  {
    char: 'miyabi',
    name: 'Miyabi',
    rarity: 'Limited 5*',
    app_free: 5.64,
    round_free: 22025,
    app_dupes: 35,
    round_dupes: 35815,
    current_app_rate: 90.09,
    prev_app_rate: 89.19,
    current_avg_score: 26861,
    prev_avg_score: 30074,
    boss_1_usage: 9.71,
    boss_1_score: 29729,
    boss_2_usage: 91.46,
    boss_2_score: 26515,
    boss_3_usage: 0.46,
    boss_3_score: 27602
  },
  {
    char: 'nekomata',
    name: 'Nekomata',
    rarity: 'Standard 5*',
    app_free: 0.6,
    round_free: 21624,
    app_dupes: 0.27,
    round_dupes: 0,
    current_app_rate: 1.15,
    prev_app_rate: 1.2,
    current_avg_score: 22522,
    prev_avg_score: 18852,
    boss_1_usage: 0.78,
    boss_1_score: 24274,
    boss_2_usage: 0.06,
    boss_2_score: 0,
    boss_3_usage: 0.39,
    boss_3_score: 18690
  },
  {
    char: 'nicole-demara',
    name: 'Nicole',
    rarity: '4*',
    app_free: 18.54,
    round_free: 24287,
    app_dupes: 14.84,
    round_dupes: 35574,
    current_app_rate: 57.32,
    prev_app_rate: 47.85,
    current_avg_score: 26160,
    prev_avg_score: 24318,
    boss_1_usage: 29.36,
    boss_1_score: 26249,
    boss_2_usage: 8.7,
    boss_2_score: 27266,
    boss_3_usage: 23.72,
    boss_3_score: 25782
  },
  {
    char: 'piper',
    name: 'Piper',
    rarity: '4*',
    app_free: 1.97,
    round_free: 20625,
    app_dupes: 1.44,
    round_dupes: 27705,
    current_app_rate: 6.31,
    prev_app_rate: 10.48,
    current_avg_score: 22878,
    prev_avg_score: 20599,
    boss_1_usage: 3.39,
    boss_1_score: 25368,
    boss_2_usage: 2.25,
    boss_2_score: 20103,
    boss_3_usage: 1.22,
    boss_3_score: 19344
  },
  {
    char: 'pulchra',
    name: 'Pulchra',
    rarity: '4*',
    app_free: 2.22,
    round_free: 17049,
    app_dupes: 1.66,
    round_dupes: 28135,
    current_app_rate: 9.66,
    prev_app_rate: 12.68,
    current_avg_score: 20789,
    prev_avg_score: 19019,
    boss_1_usage: 1.23,
    boss_1_score: 19736,
    boss_2_usage: 0.39,
    boss_2_score: 0,
    boss_3_usage: 8.81,
    boss_3_score: 21105
  },
  {
    char: 'qingyi',
    name: 'Qingyi',
    rarity: 'Limited 5*',
    app_free: 13.14,
    round_free: 23328,
    app_dupes: 11.08,
    round_dupes: 31350,
    current_app_rate: 40.06,
    prev_app_rate: 32.63,
    current_avg_score: 24448,
    prev_avg_score: 19633,
    boss_1_usage: 17.41,
    boss_1_score: 25002,
    boss_2_usage: 0.58,
    boss_2_score: 15454,
    boss_3_usage: 24.98,
    boss_3_score: 24171
  },
  {
    char: 'rina',
    name: 'Rina',
    rarity: 'Standard 5*',
    app_free: 6.8,
    round_free: 19683,
    app_dupes: 8.78,
    round_dupes: 32411,
    current_app_rate: 31.7,
    prev_app_rate: 36.09,
    current_avg_score: 23554,
    prev_avg_score: 23689,
    boss_1_usage: 2.84,
    boss_1_score: 22425,
    boss_2_usage: 12.35,
    boss_2_score: 25114,
    boss_3_usage: 19.6,
    boss_3_score: 22932
  },
  {
    char: 'seth',
    name: 'Seth',
    rarity: '4*',
    app_free: 1.67,
    round_free: 16488,
    app_dupes: 2.03,
    round_dupes: 24780,
    current_app_rate: 6.02,
    prev_app_rate: 7.64,
    current_avg_score: 18171,
    prev_avg_score: 17265,
    boss_1_usage: 2.3,
    boss_1_score: 18914,
    boss_2_usage: 1.15,
    boss_2_score: 16074,
    boss_3_usage: 3.06,
    boss_3_score: 18406
  },
  {
    char: 'soldier-11',
    name: 'Soldier 11',
    rarity: 'Standard 5*',
    app_free: 1.25,
    round_free: 17404,
    app_dupes: 0.75,
    round_dupes: 27541,
    current_app_rate: 2.94,
    prev_app_rate: 10.01,
    current_avg_score: 20329,
    prev_avg_score: 17906,
    boss_1_usage: 2.12,
    boss_1_score: 21697,
    boss_2_usage: 0.21,
    boss_2_score: 0,
    boss_3_usage: 0.81,
    boss_3_score: 18417
  },
  {
    char: 'soukaku',
    name: 'Soukaku',
    rarity: '4*',
    app_free: 4.61,
    round_free: 18127,
    app_dupes: 15.19,
    round_dupes: 29916,
    current_app_rate: 40.76,
    prev_app_rate: 39.34,
    current_avg_score: 22516,
    prev_avg_score: 26598,
    boss_1_usage: 16.23,
    boss_1_score: 21453,
    boss_2_usage: 28.25,
    boss_2_score: 23443,
    boss_3_usage: 0.63,
    boss_3_score: 17719
  },
  {
    char: 'trigger',
    name: 'Trigger',
    rarity: 'Limited 5*',
    app_free: 6.85,
    round_free: 22152,
    app_dupes: 12.12,
    round_dupes: 38946,
    current_app_rate: 45.22,
    prev_app_rate: 39.89,
    current_avg_score: 27561,
    prev_avg_score: 25272,
    boss_1_usage: 5.09,
    boss_1_score: 27461,
    boss_2_usage: 2.49,
    boss_2_score: 24621,
    boss_3_usage: 41.3,
    boss_3_score: 27676
  },
  {
    char: 'vivian',
    name: 'Vivian',
    rarity: 'Limited 5*',
    app_free: 4.7,
    round_free: 27541,
    app_dupes: 6.61,
    round_dupes: 44403,
    current_app_rate: 21.48,
    prev_app_rate: 21.48,
    current_avg_score: 30412,
    prev_avg_score: 30412,
    boss_1_usage: 10.72,
    boss_1_score: 31947,
    boss_2_usage: 4.83,
    boss_2_score: 28134,
    boss_3_usage: 7.68,
    boss_3_score: 29468
  },
  {
    char: 'yanagi',
    name: 'Yanagi',
    rarity: 'Limited 5*',
    app_free: 7.3,
    round_free: 23849,
    app_dupes: 13.79,
    round_dupes: 37240,
    current_app_rate: 46.92,
    prev_app_rate: 46.82,
    current_avg_score: 26974,
    prev_avg_score: 26609,
    boss_1_usage: 4.09,
    boss_1_score: 31312,
    boss_2_usage: 31.24,
    boss_2_score: 26095,
    boss_3_usage: 16.8,
    boss_3_score: 27321
  },
  {
    char: 'zhu-yuan',
    name: 'Zhu Yuan',
    rarity: 'Limited 5*',
    app_free: 12.89,
    round_free: 24666,
    app_dupes: 8.67,
    round_dupes: 33303,
    current_app_rate: 34.3,
    prev_app_rate: 16.06,
    current_avg_score: 25495,
    prev_avg_score: 19868,
    boss_1_usage: 24.52,
    boss_1_score: 25641,
    boss_2_usage: 0.14,
    boss_2_score: 0,
    boss_3_usage: 11.93,
    boss_3_score: 25250
  }
];
